import app from 'flarum/forum/app';

// PinoyTalks Holiday Effects — Undas ghost edition
// Active every November 1–2, using Philippine local dates (Asia/Manila).
// No external requests, no added dependencies, and no animation frames in JS.

const EXTENSION_ID = 'pinoytalks-holiday-effects';
const GHOST_CLASS = 'pt-undas-ghost';
const MANILA_OFFSET_MS = 8 * 60 * 60 * 1000; // Philippines has no DST.
const MAX_DESKTOP = 8;
const MAX_MOBILE = 4;
const MOBILE_BREAKPOINT = 700;
function getUndasWindow(now) {
  if (now === void 0) {
    now = Date.now();
  }
  const manilaYear = new Date(now + MANILA_OFFSET_MS).getUTCFullYear();
  const opening = manilaYear === 2026 ? Date.UTC(2026, 9, 28) - MANILA_OFFSET_MS : Date.UTC(manilaYear, 10, 1) - MANILA_OFFSET_MS;
  const closing = Date.UTC(manilaYear, 10, 3) - MANILA_OFFSET_MS;
  return {
    opening,
    closing,
    active: now >= opening && now < closing
  };
}
function createGhostSVG() {
  const NS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('viewBox', '0 0 60 74');
  svg.setAttribute('width', '60');
  svg.setAttribute('height', '74');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');
  const shape = document.createElementNS(NS, 'path');
  shape.setAttribute('d', 'M6 35C6 18 16 6 30 6S54 18 54 35V66Q47 58 41 65Q35 71 30 64Q24 58 19 65Q12 71 6 65Z');
  shape.setAttribute('fill', '#f6f9ff');
  shape.setAttribute('stroke', '#a6b6ca');
  shape.setAttribute('stroke-width', '1.3');
  const leftEye = document.createElementNS(NS, 'ellipse');
  leftEye.setAttribute('cx', '22');
  leftEye.setAttribute('cy', '36');
  leftEye.setAttribute('rx', '3');
  leftEye.setAttribute('ry', '4.5');
  leftEye.setAttribute('fill', '#31445f');
  const rightEye = document.createElementNS(NS, 'ellipse');
  rightEye.setAttribute('cx', '39');
  rightEye.setAttribute('cy', '36');
  rightEye.setAttribute('rx', '3');
  rightEye.setAttribute('ry', '4.5');
  rightEye.setAttribute('fill', '#31445f');
  const mouth = document.createElementNS(NS, 'ellipse');
  mouth.setAttribute('cx', '30');
  mouth.setAttribute('cy', '48');
  mouth.setAttribute('rx', '2.4');
  mouth.setAttribute('ry', '3.2');
  mouth.setAttribute('fill', '#31445f');
  svg.append(shape, leftEye, rightEye, mouth);
  return svg;
}
app.initializers.add(EXTENSION_ID, () => {
  // Protect against duplicate initialization from re-evaluated frontend bundles.
  if (window.__ptUndasGhostsInitialized) return;
  window.__ptUndasGhostsInitialized = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let layer = null;
  let emissionTimer = null;
  let boundaryTimer = null;
  let booted = false;
  const limit = () => window.innerWidth <= MOBILE_BREAKPOINT ? MAX_MOBILE : MAX_DESKTOP;
  function trimToLimit() {
    if (!layer) return;
    const ghosts = Array.from(layer.querySelectorAll(".".concat(GHOST_CLASS)));
    ghosts.slice(0, Math.max(0, ghosts.length - limit())).forEach(ghost => {
      ghost.remove();
    });
  }
  function addGhost() {
    if (!layer || document.hidden || reducedMotion.matches) return;
    if (!getUndasWindow().active) return;
    trimToLimit();
    if (layer.childElementCount >= limit()) return;
    const ghost = document.createElement('span');
    ghost.className = GHOST_CLASS;
    ghost.setAttribute('aria-hidden', 'true');

    // Keep most decoration near screen edges to protect readable content.
    const onLeft = Math.random() < 0.5;
    const x = onLeft ? 1 + Math.random() * 15 : 84 + Math.random() * 14;
    const drift = Math.round((Math.random() - 0.5) * 72);
    const size = Math.round(28 + Math.random() * (limit() === MAX_MOBILE ? 10 : 18));
    const duration = Math.round(21000 + Math.random() * 9000);
    const opacity = (0.18 + Math.random() * 0.15).toFixed(2);
    ghost.style.left = "".concat(x, "vw");
    ghost.style.setProperty('--pt-size', "".concat(size, "px"));
    ghost.style.setProperty('--pt-drift', "".concat(drift, "px"));
    ghost.style.setProperty('--pt-half-drift', "".concat(Math.round(drift * 0.5), "px"));
    ghost.style.setProperty('--pt-duration', "".concat(duration, "ms"));
    ghost.style.setProperty('--pt-opacity', opacity);
    ghost.appendChild(createGhostSVG());
    ghost.addEventListener('animationend', () => ghost.remove(), {
      once: true
    });
    layer.appendChild(ghost);

    // Safety cleanup if a browser skips animationend.
    window.setTimeout(() => ghost.remove(), duration + 1500);
  }
  function stop() {
    if (emissionTimer !== null) {
      window.clearInterval(emissionTimer);
      emissionTimer = null;
    }
    if (layer) {
      layer.remove();
      layer = null;
    }
  }
  function start() {
    if (layer || !document.body) return;
    layer = document.createElement('div');
    layer.id = EXTENSION_ID;
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);
    addGhost();
    emissionTimer = window.setInterval(() => {
      addGhost();
      if (window.innerWidth > MOBILE_BREAKPOINT && Math.random() > 0.65) {
        addGhost();
      }
    }, 6600);
  }
  function sync() {
    if (!booted) return;
    const now = Date.now();
    const _getUndasWindow = getUndasWindow(now),
      opening = _getUndasWindow.opening,
      closing = _getUndasWindow.closing,
      active = _getUndasWindow.active;
    if (active && !document.hidden && !reducedMotion.matches) start();else stop();
    if (boundaryTimer !== null) window.clearTimeout(boundaryTimer);
    boundaryTimer = null;

    // Arrange activation and precise cutoff if boundary is within timer range.
    const nextOpening = now < opening ? opening : Date.UTC(new Date(now + MANILA_OFFSET_MS).getUTCFullYear() + 1, 10, 1) - MANILA_OFFSET_MS;
    const nextBoundary = active ? closing : nextOpening;
    const delay = nextBoundary - now;
    if (delay > 0 && delay < 2147483647) {
      boundaryTimer = window.setTimeout(sync, delay + 20);
    }
  }
  function boot() {
    // Delay initial decoration to keep page content/navigation prioritized.
    window.setTimeout(() => {
      booted = true;
      sync();
      window.setInterval(sync, 60000);
    }, 3000);
  }
  document.addEventListener('visibilitychange', sync);
  window.addEventListener('pageshow', sync);
  window.addEventListener('resize', trimToLimit, {
    passive: true
  });
  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', sync);
  } else if (typeof reducedMotion.addListener === 'function') {
    reducedMotion.addListener(sync);
  }
  if (document.readyState === 'complete') boot();else window.addEventListener('load', boot, {
    once: true
  });
});